import { tr, localizedStatic } from "@/i18n/copy";
import { Bell, CalendarDays, ClipboardList, FileSignature, FileText, Landmark, QrCode, Users } from "lucide-react";

export const MANAGER_MODULES = localizedStatic([
  { id: "appointments", label: "Agenda", route: "/calendar", capability: "scheduling", icon: CalendarDays },
  { id: "customers", label: "Clienti", route: "/customers", capability: "crm", icon: Users },
  { id: "projects", label: "Progetti", route: "/projects", capability: "projects", icon: ClipboardList },
  { id: "consents", label: "Consensi", route: "/consent", capability: "consent", icon: FileSignature },
  { id: "quotations", label: "Preventivi", route: "/quotations", capability: "quotations", icon: FileText },
  { id: "finance", label: "Finanza", route: "/finance", capability: "expenses", icon: Landmark },
  { id: "team", label: "Team", route: "/team", capability: "artists", icon: Users },
  { id: "scanner", label: "Scanner QR", route: "/scanner", capability: "scheduling", icon: QrCode },
  { id: "notifications", label: "Notifiche", route: "/notifications", capability: "notifications", icon: Bell },
], [[0,"label"],[1,"label"],[2,"label"],[3,"label"],[4,"label"],[5,"label"],[6,"label"],[7,"label"],[8,"label"]]);

export const FRONT_DESK_MODULES = localizedStatic([
  { id: "appointments", label: "Agenda", route: "/calendar", capability: "scheduling", icon: CalendarDays },
  { id: "customers", label: "Clienti", route: "/customers", capability: "crm", icon: Users },
  { id: "projects", label: "Progetti", route: "/projects", capability: "projects", icon: ClipboardList },
  { id: "consents", label: "Consensi", route: "/consent", capability: "consent", icon: FileSignature },
  { id: "quotations", label: "Preventivi", route: "/quotations", capability: "quotations", icon: FileText },
  { id: "scanner", label: "Scanner QR", route: "/scanner", capability: "scheduling", icon: QrCode },
  { id: "notifications", label: "Notifiche", route: "/notifications", capability: "notifications", icon: Bell },
], [[0,"label"],[1,"label"],[2,"label"],[3,"label"],[4,"label"],[5,"label"],[6,"label"]]);

export const OWNER_MODULES = localizedStatic([
  { id: "appointments", label: "Agenda", route: "/calendar", capability: "scheduling", icon: CalendarDays },
  { id: "customers", label: "Clienti", route: "/customers", capability: "crm", icon: Users },
  { id: "projects", label: "Progetti", route: "/projects", capability: "projects", icon: ClipboardList },
  { id: "consents", label: "Consensi", route: "/consent", capability: "consent", icon: FileSignature },
  { id: "quotations", label: "Preventivi", route: "/quotations", capability: "quotations", icon: FileText },
  { id: "finance", label: "Finanza", route: "/finance", capability: "expenses", icon: Landmark },
  { id: "notifications", label: "Notifiche", route: "/notifications", capability: "notifications", icon: Bell },
  { id: "brand", label: "Brand e affiliazioni", route: "/hq", ownerOnly: true, icon: Users },
  // Team and Setup are owner-only canonical operations, not commercial plan modules.
  { id: "team", label: "Team", route: "/team", ownerOnly: true, icon: Users },
], [[0,"label"],[1,"label"],[2,"label"],[3,"label"],[4,"label"],[5,"label"],[6,"label"],[7,"label"],[8,"label"]]);

export function availableRoleModules(workspace, registry) {
  if (!workspace?.role || workspace.role === "platform_admin") return [];
  const capabilities = workspace.capabilities || {};
  return registry.filter((module) => !module.capability || Boolean(capabilities[module.capability]?.length));
}

export function availableOwnerModules(workspace) {
  if (workspace?.role !== "studio_owner" || !workspace?.scope?.studio_id) return [];
  return OWNER_MODULES.filter((module) => module.id === "brand"
    ? ["hq", "affiliate"].includes(workspace.brand_access?.mode)
    : module.ownerOnly || Boolean(workspace.capabilities?.[module.capability]?.length))
    .map(module => module.id === "brand" && workspace.brand_access?.mode === "affiliate"
      ? {...module, label: tr("La mia affiliazione")} : module);
}
